/** Tabs available in the caselaw reference renderer (Opinion vs. Citation Analysis). */
export enum CaseLawReferenceTab {
  source = 'source',
  citator = 'citator',
}
